module.exports = __webpack_public_path__ + "img/yj_more_fuli.66adb423.png";